export const DEF_DATE = 'LL'
export const DEF_DATE_TIME = 'LLL'
export const DEF_TIME = 'LT'
